/**
 * Theme contract — shared across backend (validation) and frontend (catalog,
 * rendering).
 *
 * `ThemeTokens` is the design system: the 24 token roles below are the only
 * colour surface a component may read from. Each theme in
 * `packages/frontend/src/themes/` is one substitution into these slots, and
 * `createAppTheme()` / `tokensToCssVars()` in `packages/frontend/src/theme.ts`
 * are the only places they become MUI palette entries and `:root` CSS
 * variables. Adding a role here means updating every theme.
 */
export const THEME_IDS = [
    'industrial-laser',
    'backstage-synth',
    'vhs-control-room',
    'rigging-bay',
    'classic-light',
    'chauvet-corporate',
];
export const DEFAULT_THEME_ID = 'industrial-laser';
export function isThemeId(value) {
    return typeof value === 'string' && THEME_IDS.includes(value);
}
//# sourceMappingURL=theme.types.js.map